// extracted by mini-css-extract-plugin
module.exports = {"stationId":"styles_stationId__2AH0P","alert":"styles_alert__1qoxc","btnNew":"styles_btnNew__o-P0N","emptyList":"styles_emptyList__12e72","imgPlus":"styles_imgPlus__1RBZp"};